import { Calculation } from '@servicetitan/financing-api-client';
import { PrequalsApi } from '@servicetitan/financing-api-client/src/prequals-api';
import { SetupDataStore } from '@servicetitan/financing-workflow-shared';
import { useDependencies } from '@servicetitan/react-ioc';
import { useQuery } from '@tanstack/react-query';
import { PrequalsStore } from '../prequals-financing-information/prequalsStore';

export const useLoadPrequalsPlans = (amount: number, state?: string) => {
    const { setupData } = SetupDataStore.useStore();
    const { isAmountConfirmed } = PrequalsStore.useStore();
    const prequalId = setupData?.prequalificationId;
    const [apiClient] = useDependencies(PrequalsApi);

    const stateToUse = state ?? setupData?.state;

    return useQuery<Calculation[]>({
        queryKey: ['prequals', prequalId, 'calculations', amount, stateToUse],
        queryFn: () =>
            apiClient
                .prequalificationsGetPrequalificationCalculations({
                    prequalificationId: prequalId ?? '',
                    amount,
                    state: stateToUse ?? '',
                })
                .then(response => response.data),
        enabled: !!prequalId && amount > 0 && isAmountConfirmed,
    });
};
